<template>
  <div class="card p-shadow-24 chats-view">
    <div class="p-d-flex p-ai-center p-jc-between chats-view__header">
      <h1 class="chats-view__title">Chats Ativos</h1>
    </div>
    <hr />
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />

    <div v-if="loading" class="chats-view__state">
      <i class="pi pi-spin pi-spinner mr-2"></i>
      <span>A carregar chats...</span>
    </div>
    <div v-else-if="!pats.length" class="chats-view__state">Sem chats ativos no momento.</div>
    <DataTable
      v-else
      :value="pats"
      :filters.sync="filters"
      filterDisplay="row"
      :loading="loading"
      dataKey="id"
      :paginator="true"
      :rows="50"
      class="p-datatable-sm"
      responsiveLayout="scroll"
      removableSort
      sortMode="single"
      :scrollable="true"
      scrollHeight="flex"
      :autoLayout="true"
      stripedRows
      :expandedRows.sync="expandedRows"
      @row-expand="onRowExpand"
      @row-collapse="onRowCollapse"
    >
      <Column :expander="true" />
      <Column
        field="id"
        header="PAT"
        sortable
        filter
        filterMatchMode="contains"
      >
        <template #filter="{ filterModel, filterCallback }">
          <span class="p-input-icon-left chats-view__filter">
            <i class="pi pi-search" />
            <InputText
              v-model="filterModel.value"
              placeholder="Pesquisar PAT"
              @input="filterCallback()"
            />
          </span>
        </template>
      </Column>
      <Column
        field="clientName"
        header="Cliente"
        sortable
        filter
        filterMatchMode="contains"
      >
        <template #body="slotProps">
          {{ slotProps.data.clientName}}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <span class="p-input-icon-left chats-view__filter">
            <i class="pi pi-search" />
            <InputText
              v-model="filterModel.value"
              placeholder="Pesquisar cliente"
              @input="filterCallback()"
            />
          </span>
        </template>
      </Column>
      <Column
        field="entityName"
        header="Entidade"
        sortable
        filter
        filterMatchMode="contains"
      >
        <template #body="slotProps">
          {{ slotProps.data.entityName || 'Sem Entidade' }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <span class="p-input-icon-left chats-view__filter">
            <i class="pi pi-search" />
            <InputText
              v-model="filterModel.value"
              placeholder="Pesquisar cliente"
              @input="filterCallback()"
            />
          </span>
        </template>
      </Column>
      <Column
        field="alertLabel"
        header="Alertas"
        sortable
        filter
        filterMatchMode="equals"
      >
        <template #body="slotProps">
          <span
            :class="[
              'chats-view__badge',
              slotProps.data.hasAlert ? 'chats-view__badge--danger' : 'chats-view__badge--success'
            ]"
          >
            {{ slotProps.data.alertLabel }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown
            class="chats-view__filter-select"
            :options="alertOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Filtrar alerta"
            showClear
            :value="filterModel.value"
            @change="e => { filterModel.value = e.value; filterCallback(); }"
            @clear="() => { filterModel.value = null; filterCallback(); }"
          />
        </template>
      </Column>
      <Column header="Ações" :bodyStyle="{ textAlign: 'right' }">
        <template #body="slotProps">
          <Button
            label="Abrir Chat"
            icon="pi pi-external-link"
            class="p-button-text p-button-sm"
            @click="openPatChat(slotProps.data.id)"
          />
        </template>
      </Column>

      <template #expansion="slotProps">
        <div class="chats-view__expansion">
          <div class="chats-view__expansion-grid">
            <div class="chats-view__expansion-item">
              <span class="chats-view__expansion-label">Cliente</span>
              <span class="chats-view__expansion-value">
                {{ slotProps.data.clientName || 'Cliente desconhecido' }}
              </span>
            </div>
            <div class="chats-view__expansion-item">
              <span class="chats-view__expansion-label">Entidade</span>
              <span class="chats-view__expansion-value">
                {{ slotProps.data.entityName || 'Sem entidade' }}
              </span>
            </div>
            <div class="chats-view__expansion-item">
              <span class="chats-view__expansion-label">Mensagens não lidas</span>
              <span class="chats-view__expansion-value">
                {{ slotProps.data.unreadCount ?? (slotProps.data.hasAlert ? 'Sim' : 'Não') }}
              </span>
            </div>
          </div>

          <div class="chats-view__inline-chat">
            <Chat :pat-id="slotProps.data.id" :key="slotProps.data.id" style="width: 100%;" />
          </div>
        </div>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Chat from '../components/pats/Chat.vue';
import ChatService from '../services/chat.service';

export default {
  name: "ChatView",
  components: {
    DataTable,
    Column,
    Button,
    InputText,
    Dropdown,
    Chat,
  },
  data () {
    return {
      loading: false,
      pats: [],
      expandedRows: [],
      filters: {
        id: { value: null, matchMode: 'contains' },
        clientName: { value: null, matchMode: 'contains' },
        entityName: { value: null, matchMode: 'contains' },
        alertLabel: { value: null, matchMode: 'equals' },
      },
      alertOptions: [
        { label: 'Mensagens por ler', value: 'Mensagens por ler' },
        { label: 'Sem novas mensagens', value: 'Sem novas mensagens' }
      ],
    }
  },
  async created() {
    await this.getPatsWithChats();
  },
  methods: {
    openPatChat(id) {
      window.open(`/pats/${id}`, '_blank');
    },
    async getPatsWithChats() {
      this.loading = true;
      try {
        const response = await ChatService.getPatsWithChats();
        const pats = Array.isArray(response) ? response : [];
        this.pats = pats.map((pat) => ({
          ...pat,
          clientName: pat?.client?.name || '',
          entityName: pat?.entity?.name || '',
          hasAlert: false,
          unreadCount: null,
          alertLabel: 'Sem novas mensagens',
        }));
        this.expandedRows = [];
        if (this.pats.length) {
          await this.refreshPatNotifications();
        }
      } catch (error) {
        console.error("Erro ao carregar PATs com chat:", error);
        if (this.$toast) {
          this.$toast.add({ severity: "error", summary: "Erro ao carregar chats ativos.", life: 4000 });
        }
      } finally {
        this.loading = false;
      }
    },
    onRowExpand(event) {
      this.expandedRows = event?.data ? [event.data] : [];
    },
    onRowCollapse() {
      this.expandedRows = [];
    },
    async refreshPatNotifications() {
      const results = await Promise.allSettled(
        this.pats.map(async (pat, index) => {
          const patId = pat?.id;
          if (!patId) return;

          try {
            const response = await ChatService.getMessagesNotificationsByPat(patId);
            const count = Number(response) || 0;
            this.$set(this.pats, index, {
              ...this.pats[index],
              hasAlert: count > 0,
              unreadCount: count,
              alertLabel: count > 0 ? 'Mensagens por ler' : 'Sem novas mensagens',
            });
          } catch (error) {
            this.$set(this.pats, index, {
              ...this.pats[index],
              hasAlert: false,
              unreadCount: null,
              alertLabel: 'Sem novas mensagens',
            });
            throw error;
          }
        })
      );

      const hadError = results.some(result => result.status === 'rejected');
      if (hadError && this.$toast) {
        this.$toast.add({ severity: "error", summary: "Erro ao verificar notificações.", life: 4000 });
      }
    },
  },
}
</script>

<style scoped>
.chats-view__state {
  margin-top: 1.5rem;
  font-size: 1rem;
  color: #94a3b8;
  text-align: center;
}

.chats-view__filter {
  width: 100%;
}

.chats-view__filter .p-inputtext {
  width: 100%;
}

.chats-view__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.chats-view__badge--danger {
  background: rgba(248, 113, 113, 0.2);
  color: #b91c1c;
}

.chats-view__badge--success {
  background: rgba(52, 211, 153, 0.15);
  color: #047857;
}

.chats-view__expansion {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border-radius: 0.5rem;
}

.chats-view__expansion-grid {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
}

.chats-view__expansion-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-width: 12rem;
  gap: 0.25rem;
}

.chats-view__expansion-label {
  width: 100%;
  font-size: 0.7rem;
  text-transform: uppercase;
  color: #94a3b8;
  letter-spacing: 0.08em;
}

.chats-view__expansion-value {
  width: 100%;
  font-size: 0.9rem;
  font-weight: 600;
  color: #0f172a;
}

.chats-view__inline-chat {
  margin-top: 1rem;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.chats-view__inline-chat :deep(.chat-wrapper) {
  width: 100%;
  max-width: 100%;
  max-height: 400px;
}

.chats-view__inline-chat :deep(.chat-messages) {
  max-height: 220px;
}

.chats-view__inline-chat :deep(.chat-input) {
  padding: 0;
  padding-top: 0.75rem;
}

</style>
